import ForecastingVsBudget from "../components/forecastingvsbudget";

const ForecastingVsBudgetPage = () => {
    return (<>
        <ForecastingVsBudget />
    </>)
}

export default ForecastingVsBudgetPage;